import { Component, ReactElement } from 'react'
import { BountyAppState, Reward, RewardStatus } from 'interfaces/bounty'
import { RewardsHistoryItemWithId } from 'components/features/rewards/rewardPage/store'
import { TableContextType, TableContext } from 'components/molecules/tables/Table2'
import { formatUSDate } from 'helpers/dateTimeHelpers'
import * as rowMobileStyles from 'styles/molecules/tables/CommonRowMobile.css'
import * as styles from 'components/features/pfm/RewardDetails/RewardDetailsRowMobile.css'
import * as cn from 'classnames'
import TableNoWrapValue from 'components/atoms/tables/TableNoWrapValue'
import Progress from 'components/features/pfm/RewardDetails/Progress'
import StatusCopy from 'components/features/pfm/RewardDetails/StatusCopy'
import DismissButton from 'components/features/pfm/RewardDetails/DismissButton'
import withContext from 'hocs/withContext/withContext'
import { mapRowInAcceptableRewardDetailsRowFormat } from 'components/features/pfm/RewardDetails/RewardDetailsRow'
import TextButton from 'components/atoms/buttons/TextButton'


type RewardDetailsRowMobileProps = {
  table: TableContextType
  row: RewardsHistoryItemWithId
  isDismissing: boolean
  onProgressClick: (modalType: BountyAppState['reward']['modalType']) => void
  onDismissClick: () => void
  onOpenCryptoDetails: (cryptoOrderId: string) => void
}

class RewardDetailsRowMobile extends Component<RewardDetailsRowMobileProps> {
  render () {
    const { row, isDismissing, onDismissClick } = this.props
    const {
      isCrypto,
      name,
      amount,
      description,
      status,
      lastUpdated,
    } = mapRowInAcceptableRewardDetailsRowFormat(row)

    const rowKey = this.props.table.getRowKey(row)

    const descriptionTheme = (() => {
      if (row.transaction_type === 'crypto') {
        if (row.type === 'buy') {
          return 'buy'
        }
        if (row.type === 'sell') {
          return 'sell'
        }
      }

      return 'regular'
    })()

    return (
      <tr key={ rowKey }>
        <td>
          <div className={ rowMobileStyles.commonRowMobile }>
            <div className={ rowMobileStyles.line }>
              <div className={ cn(rowMobileStyles.linePart, rowMobileStyles.left) }>
                <div className={ rowMobileStyles.title }>
                  { name }
                </div>
                { this.renderDescription(description, descriptionTheme) }
              </div>
              <div className={ cn(rowMobileStyles.linePart, rowMobileStyles.right) }>
                <div className={ cn(rowMobileStyles.value, styles.amount) }>
                  <TableNoWrapValue>{ amount }</TableNoWrapValue>
                </div>
              </div>
            </div>
            <div className={ cn(rowMobileStyles.ctaLine, styles.rowFooter) }>
              <div className={ cn(rowMobileStyles.linePart, rowMobileStyles.left) }>
                { this.renderStatus(status, lastUpdated) }
              </div>
              <div className={ cn(rowMobileStyles.linePart, rowMobileStyles.right) }>
                {isCrypto
                  ? <TextButton size='regular' onClick={ this.handleOpenCryptoDetails }>Details</TextButton>
                  : <DismissButton reward={ row as Reward } isLoading={ isDismissing } onClick={ onDismissClick } />}
              </div>
            </div>
          </div>
        </td>
      </tr>
    )
  }

  renderDescription (description: string, theme: 'regular' | 'buy' | 'sell'): ReactElement | null {
    return description ? (
      <div className={ cn(rowMobileStyles.subtitle, styles.description, styles[theme]) }>
        { description }
      </div>
    ) : null
  }

  handleClickOnProgress = () => {
    const {
      row: {
        transaction_type,
      },
      onProgressClick,
    } = this.props
    onProgressClick(transaction_type === 'crypto' ? 'crypto' : 'cash')
  }

  handleOpenCryptoDetails = () => {
    const { row, onOpenCryptoDetails } = this.props
    onOpenCryptoDetails(row.uniqKey)
  }

  renderStatus (
    status: RewardStatus,
    lastUpdated: string
  ) {
    return (
      <div className={ styles.statusWrapper } onClick={ this.handleClickOnProgress }>
        { this.renderProgress(status) }
        <div className={ styles.statusCopyWrapper }>
          <StatusCopy status={ status } />
        </div>
        <div className={ styles.date }>
          on { formatUSDate(lastUpdated) }
        </div>
      </div>
    )
  }

  renderProgress (status: RewardStatus) {
    if (status === 'expired') {
      return null
    }

    return (
      <div className={ styles.progressWrapper }>
        <Progress status={ status } onClick={ this.handleClickOnProgress } />
      </div>
    )
  }
}

export default withContext(TableContext, 'table')(RewardDetailsRowMobile)
